import { isDesktop } from '../../utils/device/identifyDevice';

export default navigationPath => {
  document.body.dispatchEvent(
    new CustomEvent('dataStateChange', {
      detail: {
        action: 'jl.navTracking',
        type: isDesktop() ? 'tf' : 'sf',
        navigation: navigationPath,
      },
    })
  );
};
